import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';

import { PhoneChangeBody, PhoneChannel, PhoneCodeSent, PhoneConfirmed, PhoneVerificationStatus } from '../models';

interface PhoneVerificationResponse<T> {
    title: string;
    message: string;
    data: T;
}

/**
 * ADM-813 — verificación del teléfono del usuario de la sesión (`/api/users/me/phone-verification`).
 * Solo HTTP y sin estado: el flujo vive en `fina-phone-verification`. `providedIn: 'root'` y fuera del
 * array `services` de `CreditosModule`, como el vigía. La identidad sale del JWT (el interceptor pone
 * `x-access-token` y `tenantid`). Nada se cachea: el estado se pide en cada entrada a la solicitud.
 */
@Injectable({ providedIn: 'root' })
export class PhoneVerificationService {
    private readonly base = `${environment.API_URL}/users/me/phone-verification`;

    constructor(private http: HttpClient) {}

    getStatus$(): Observable<PhoneVerificationStatus> {
        return this.http.get<PhoneVerificationResponse<PhoneVerificationStatus>>(this.base).pipe(map(res => res.data));
    }

    send$(channel: PhoneChannel): Observable<PhoneCodeSent> {
        return this.http.post<PhoneVerificationResponse<PhoneCodeSent>>(`${this.base}/send`, { channel }).pipe(map(res => res.data));
    }

    /** `phone`: 10 dígitos sin el 0 inicial. La contraseña solo viaja en este body. */
    change$(body: PhoneChangeBody): Observable<PhoneCodeSent> {
        return this.http.post<PhoneVerificationResponse<PhoneCodeSent>>(`${this.base}/change`, body).pipe(map(res => res.data));
    }

    resend$(channel: PhoneChannel): Observable<PhoneCodeSent> {
        return this.http.post<PhoneVerificationResponse<PhoneCodeSent>>(`${this.base}/resend`, { channel }).pipe(map(res => res.data));
    }

    confirm$(code: string): Observable<PhoneConfirmed> {
        return this.http.post<PhoneVerificationResponse<PhoneConfirmed>>(`${this.base}/confirm`, { code }).pipe(map(res => res.data));
    }
}
